import { render, staticRenderFns } from "./perDR.vue?vue&type=template&id=217adf93&scoped=true"
import script from "./perDR.vue?vue&type=script&lang=js"
export * from "./perDR.vue?vue&type=script&lang=js"
import style0 from "./perDR.vue?vue&type=style&index=0&id=217adf93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217adf93",
  null
  
)

export default component.exports